import { useSyncExternalStore } from 'react'

/**
 * Somebody asking for the weekly check-in before its day comes — the nutrition spec, The
 * weekly check-in: "It can also be opened before its day comes, from the account, whether or
 * not a weigh-in is in."
 *
 * It is a flag rather than an address because it is not a page you can be linked to: the
 * check-in is raised over whatever the app was opened on, by the app deciding it is due, and
 * asking for it early is the same raising by hand. Giving it a URL would mean a reload could
 * land on a check-in nobody asked for this time.
 */

let asked = false
const listeners = new Set<() => void>()

function tell(): void {
  for (const listener of listeners) {
    listener()
  }
}

/** Raise the check-in now, whether or not its weekday has come. */
export function askForWeeklyCheckin(): void {
  if (asked) {
    return
  }
  asked = true
  tell()
}

/** Put the asking down again — what closing the check-in does with it. */
export function weeklyCheckinAnswered(): void {
  if (!asked) {
    return
  }
  asked = false
  tell()
}

export function useWeeklyCheckinAsked(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => asked,
    () => false,
  )
}
